export const Relationships = {
  PageTemplate: {
    type: 'node--page_template',
    value: 'title'
  },
  File: {
    type: 'file--file',
    step: 'uri',
    value: 'url'
  },
  Pillar: {
    type: 'taxonomy_term--pillar_type',
    value: 'name'
  },
  Button: {
    type: 'paragraph--button'
  }
};
